export enum TaskTypesTypes {
    GET_TASK_TYPES_LIST = '@taskTypes/GET_TASK_TYPES_LIST',
    REQUEST_GET_TASK_TYPES_LIST = '@taskTypes/REQUEST_GET_TASK_TYPES_LIST',
}

export type TaskType = {
    id: string;
    name: Record<string, string>;
    type: string;
};

export type TaskTypesState = {
    isLoading: boolean;
    taskTypes: TaskType[];
};

export type TaskTypesAction<Payload> = {
    type: TaskTypesTypes;
    payload: Payload;
};

export type TaskTypesReducer = (state: TaskTypesState, actions: TaskTypesAction<TaskTypesState>) => TaskTypesState;
